const sipHelper = {

  getTarget (target, domain) {
    if (target.startsWith('sip:')) {
      return target
    } else {
      return `sip:${target}@${domain}`
    }
  },

  getOptions (extraHeaders = []) {
    return {
      sessionTimersExpires: 120,
      mediaConstraints: {
        audio: true,
        video: false
      },
      extraHeaders: extraHeaders
    }
  },

  getRealmFromSip (realm) {
    realm = realm.split('@')

    if (realm.length < 2) {
      return
    }

    return realm[1]
  }

}

export default sipHelper
